<script setup>
const processCards = [
  {
    number: 1,
    title: 'howWorks.items.0.title',
    text: 'howWorks.items.0.text',
  },
  {
    number: 2,
    title: 'howWorks.items.1.title',
    text: 'howWorks.items.1.text',
  },
  {
    number: 3,
    title: 'howWorks.items.2.title',
    text: 'howWorks.items.2.text',
  },
  {
    number: 4,
    title: 'howWorks.items.3.title',
    text: 'howWorks.items.3.text',
  },
];
</script>

<template>
  <div class="section-process">
    <div class="container">
      <div class="section-process__inner">
        <div class="section-process__head">
          <h2 class="section-process__title">
            <span class="section-process__font section-process__font--title">
              {{ $t('howWorks.title') }}
            </span>
          </h2>
        </div>

        <div class="section-process__cards">
          <CardProcess
            v-for="(item, index) in processCards"
            :key="index"
            :number="item.number"
            :title="$t(item.title)"
            :text="$t(item.text)"
            class="section-process__card"
            :class="`section-process__card--number--${index + 1}`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.section-process {
  &__inner {
    background: transparent url('/images/section/works/bg.png') no-repeat center /
      contain;
    padding-block-start: em(74);
    padding-inline-end: em(68);
    padding-block-end: em(124);
    padding-inline-start: em(75);

    @include media-breakpoint-mobile {
      background-image: url('/images/section/works/bg-mobile.png');
      background-size: 100% 100%;
      padding-block-start: em(38);
      padding-inline: 0;
      padding-block-end: em(69);
    }
  }

  &__head {
    margin-bottom: em(40);

    @include media-breakpoint-mobile {
      text-align: center;
    }
  }

  &__title {
    display: inline-block;
    padding-bottom: em(8);
    margin-bottom: em(-8);

    @include gradient-text(
      linear-gradient(90deg, $color-main-30 25.45%, $color-black 100%)
    );
  }

  &__font {
    &--title {
      font-weight: $font-weight-semi-bold;
      font-size: em(80);
      line-height: 1;

      @include media-breakpoint-mobile {
        font-size: em(30);
      }
    }
  }

  &__cards {
    position: relative;
    min-height: em(512);
  }

  &__card {
    position: relative;

    &::after {
      content: '';
      position: absolute;
      background: transparent no-repeat center / contain;
    }

    &:not(:last-child) {
      &::after {
        @include media-breakpoint-mobile {
          background-image: url('/icons/process/arrow-bottom.svg');
          height: em(49);
          width: em(14);
          top: 100%;
          left: 50%;
          transform: translateX(-50%);
        }
      }
    }

    @include media-breakpoint-desktop {
      position: absolute;
    }

    & + & {
      @include media-breakpoint-mobile {
        margin-top: em(47);
      }
    }

    &--number {
      &--1 {
        @include media-breakpoint-desktop {
          width: em(467);
          top: em(122);
          inset-inline-start: 0;
        }

        &::after {
          @include media-breakpoint-desktop {
            width: em(285);
            height: em(144);
            background-image: url('/icons/process/arrow-1.svg');
            top: 100%;
            inset-inline-end: em(-35);

            @include rtl {
              transform: scaleX(-1);
            }
          }
        }
      }

      &--2 {
        &::after {
          @include media-breakpoint-desktop {
            content: unset;
          }
        }

        @include media-breakpoint-desktop {
          width: em(406);
          top: em(304);
          inset-inline-start: em(499);
        }
      }

      &--3 {
        @include media-breakpoint-desktop {
          width: em(495);
          bottom: em(333);
          inset-inline-end: em(283);
        }

        &::before {
          @include media-breakpoint-desktop {
            content: '';
            position: absolute;
            background: transparent url('/icons/process/arrow-2.svg') no-repeat
              center / contain;
            width: em(252);
            height: em(285);
            inset-inline-end: 100%;
            top: calc(100% - #{em(157)});

            @include rtl {
              transform: scaleX(-1);
            }
          }
        }

        &::after {
          @include media-breakpoint-desktop {
            width: em(158);
            height: em(173);
            background-image: url('/icons/process/arrow-3.svg');
            top: 100%;
            inset-inline-start: em(166);

            @include rtl {
              transform: scaleX(-1);
            }
          }
        }
      }

      &--4 {
        &::after {
          content: unset;
        }

        @include media-breakpoint-desktop {
          width: em(495);
          top: em(213);
          inset-inline-end: 0;
        }
      }
    }
  }
}
</style>
